import React, { useRef } from 'react';
import I18n from 'modules/i18n';
import { UnstyledButton } from '@/components/ui/Buttons';
import Icon from '@/components/ui/Icon';
import { Input } from '@/components/ui/Form';
import { buttonFocusRing } from '@/components/ui/ui.constants';
import cn from '@/utils/cn';
import useCorrelationsStore from '../useCorrelationsStore';

const INPUT = [
  'tw-h-[31px] tw-py-0 tw-pl-[30px] tw-pr-[26px] tw-bg-white',
  'tw-leading-5.5 tw-tracking-lighter placeholder:tw-text-dark-grey',
];

// AIDEV-NOTE: `buttonFocusRing` minus its ::before glow, which a void <input> can never render.
const FOCUS_RING = [
  'focus-visible:tw-outline focus-visible:tw-outline-2',
  'focus-visible:tw-outline-tci-purple focus-visible:tw-outline-offset-2',
];

const StandardsSearch = () => {
  const inputRef = useRef<HTMLInputElement>(null);
  const standardsQuery = useCorrelationsStore(s => s.standardsQuery);
  const setStandardsQuery = useCorrelationsStore(s => s.setStandardsQuery);
  const label = I18n.t('search_standards');

  const clear = () => {
    setStandardsQuery('');
    inputRef.current?.focus();
  };

  return (
    <div className="tw-px-2 tw-pb-2">
      <div className="tw-relative">
        <Icon
          className="tw-absolute tw-left-[9px] tw-top-1/2 tw--translate-y-1/2 tw-z-10
                     tw-text-dark-grey tw-pointer-events-none"
          icon="Search"
          size={14}
        />
        <Input
          ref={inputRef}
          aria-label={label}
          className={cn(INPUT, FOCUS_RING)}
          containerClasses="tw-w-full"
          name="standards-search"
          placeholder={label}
          type="text"
          value={standardsQuery}
          variant="inline"
          onChange={event => setStandardsQuery(event.target.value)}
        />
        {standardsQuery && (
          <UnstyledButton
            aria-label={I18n.t('clear_search')}
            className={cn(buttonFocusRing, 'tw-absolute tw-right-[1px] tw-top-1/2 tw--translate-y-1/2 tw-z-10',
              'tw-h-6 tw-w-6 tw-flex tw-items-center tw-justify-center',
              'tw-text-dark-grey hover:tw-text-tci-purple')}
            onClick={clear}
          >
            <Icon icon="Close" size={12} />
          </UnstyledButton>
        )}
      </div>
    </div>
  );
};

export default StandardsSearch;
